import { Component, Input } from '@angular/core';
import { CompanyWithFiles } from '../../../domain/models/company/company-with-files';
import { TranslatePipe } from '@ngx-translate/core';
import { formatCnpj } from '../../../../../common/helpers/company-utils';

@Component({
  selector: 'app-company-card',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './company-card.component.html',
  styleUrl: './company-card.component.scss',
})
export class CompanyCardComponent {
  @Input() company!: CompanyWithFiles;
  protected readonly formatCnpj = formatCnpj;
}
